import ApiRequest from "../util/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class ExportedDonation {
    getAll = async () => {
        return await ApiRequest.set("/v1/exported_donation", "GET");
    }
}
